import { SerializedError } from "@reduxjs/toolkit";
import { ActiveToolFacetType } from "./form";
import { EntityType, IBreadcrumb, ToolType } from "./general";

export enum NewsletterMessageType {
  success = "success",
  already_subscribed = "already_subscribed",
}

export interface INewsletterAPIData {
  successCodes?: string[] | null;
  successMessage?: string | null;
  errorCodes?: string[] | null;
  error?: SerializedError | string | null;
}

export interface ISearchResult {
  highlights: {
    title?: string;
    intro?: string;
  };
  document: {
    id: string;
    breadcrumbs: IBreadcrumb[];
    title: string;
    intro: string;
    url: string;
    bundle: EntityType;
    toolType?: {
      id: string;
      label: string;
      key: ToolType;
    };
    subToolType?: {
      id: string;
      label: string;
      key: string;
    };
    created: string;
    metaImage: string;
    event_timestamps?: string[];
    event_type?:
      | "one-day-event"
      | "multi-day-event"
      | "multi-day-event-non-consecutive";
  };
}

export interface ISearchResults {
  results: ISearchResult[];
  total: number;
}

export interface ISearchData {
  page: number;
  query: string;
  amount: number;
  type?: EntityType;
  facets?: { [key: string]: string[] };
  prioritiseDossiersAndTools: boolean;
}

export interface IToolSearchData {
  page: number;
  amount: number;
  term?: string;
  facets: ActiveToolFacetType;
}
